// src/components/StyledCard.js
import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { styled } from '@mui/system';

const StyledCard = styled(Card)(({ theme, color }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2),
  borderRadius: '16px',
  backgroundColor: theme.palette.background.default,
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
  '& .icon-wrapper': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '50px',
    height: '50px',
    borderRadius: '50%',
    backgroundColor: color || theme.palette.primary.light,
    marginRight: theme.spacing(2),
  },
}));

const StyledCardComponent = ({ icon, number, description, color }) => {
  return (
    <StyledCard color={color}>
      <Box className="icon-wrapper">{icon}</Box>
      <CardContent sx={{ padding: 0 }}>
        <Typography variant="h4" component="div">
          {number}
        </Typography>
        <Typography variant="body1" color="textSecondary">
          {description}
        </Typography>
      </CardContent>
    </StyledCard>
  );
};

export default StyledCardComponent;
